import { type MergeResponse } from 'api/hooks/useLegacyMerge/types'

export const useLegacyMergeResponses: MergeResponse = {
  commitId: 'a94a8fe5ccb19ba61c4c0873d391e987982fbbd3'
}
